import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { useDevLogging } from "../dev-logging/DevLoggingContext";
import { useConfig } from "./AppConfigHook"; // Set the default state values for each context

export var ApplicationConfigContext = createContext({});
export var ApplicationConfigContextProvider = function ApplicationConfigContextProvider(_ref) {
  var children = _ref.children,
      configItems = _ref.configItems;
  var hook = useConfig(configItems);

  var _useDevLogging = useDevLogging(),
      stateTracker = _useDevLogging.stateTracker;

  var configContext = useMemo(function () {
    stateTracker.trackState({
      config: _objectSpread({}, hook.config, {
        configItems: configItems
      }),
      floConfig: _objectSpread({}, hook.floConfig)
    });
    return _objectSpread({}, hook);
  }, [hook.config, hook.floConfig]);
  return /*#__PURE__*/React.createElement(ApplicationConfigContext.Provider, {
    value: configContext
  }, children);
};
export var useAppConfig = function useAppConfig() {
  return useContext(ApplicationConfigContext);
};